import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import ReactFullpage from '@fullpage/react-fullpage';

import './style.scss';

import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

// Import pages
import Home from './presets/home';
import HomeIE from './presets/home/isIE';
import HomePopup from '../components/Home/Popup';
import Group from './presets/group/index.new';
import Company from './presets/company';
import About from './presets/about';
import Interactive from './presets/interactive';
import Contact from './presets/contact';
import Grid from './presets/grid';
import Directors from './presets/directors';
import SharePrice from './presets/shareprice';
import History from './presets/history';
import KeyFacts from './presets/keyfacts';
import KeyFactsIE from './presets/keyfacts/isIE';
import Iframe from './presets/iframe';
import PrivateLabelSupplyChain from './presets/private-label-supply-chain';
import PrivateLabelSupplyChainCountry from './presets/private-label-supply-chain-country';

export default class Router extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popup: false,
            data: require('./data/' + this.props.request + '.json'),
        };
    }
    render() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
        const { title, shortname, url, nav, metaDescription, metaImage } = this.props;
        const { data, popup } = this.state;
        const fullurl = 'https://www.jdplc.com' + url;
        // Construct page
        return (
            <Fragment>
                <Helmet>
                    <title>{title} - JD Group</title>
                    <meta name="description" content={metaDescription} />
                    <meta name="og:description" content={metaDescription} />
                    <meta name="og:image" content={metaImage} />
                    <link rel="canonical" href={fullurl} />
                </Helmet>
                <Navigation style={data.nav} fill={data.fill} title={title} url={url} nav={nav} />
                {data.fill &&
                data.theme !== 'group' &&
                data.theme !== 'private-label-supply-chain' &&
                data.theme !== 'directors' ? (
                    <div className="navgap"></div>
                ) : null}
                <section className={data.theme}>
                    {data.theme === 'home' ? (
                        <ReactFullpage
                            scrollBar
                            licenseKey={'509941D1-3F034827-933D440A-25570100'}
                            verticalCentered
                            responsiveWidth={'951'}
                            render={comp => {
                                return (
                                    <Fragment>
                                        <ReactFullpage.Wrapper>
                                            <div className="section">
                                                <div
                                                    className={
                                                        popup
                                                            ? data.sections[0].style + ' blur'
                                                            : data.sections[0].style
                                                    }
                                                    dangerouslySetInnerHTML={
                                                        data.sections[0].container
                                                            ? null
                                                            : {
                                                                  __html: data.sections[0].content,
                                                              }
                                                    }
                                                ></div>
                                            </div>
                                            <div className="contentBlock black section">
                                                <div className="container">
                                                    {this.props.browser &&
                                                    this.props.browser.name === 'ie' &&
                                                    (this.props.browser.version === '11.0.0' ||
                                                        this.props.browser.version === '10.0.0' ||
                                                        this.props.browser.version === '9.0.0') ? (
                                                        <HomeIE />
                                                    ) : (
                                                        <Home />
                                                    )}
                                                </div>
                                            </div>
                                            <div className="section footer-home fp-auto-height">
                                                <Footer />
                                            </div>
                                        </ReactFullpage.Wrapper>
                                    </Fragment>
                                );
                            }}
                        />
                    ) : (
                        data.sections.map((section, key) => {
                            return (
                                <div
                                    key={key}
                                    className={popup ? section.style + ' blur' : section.style}
                                    dangerouslySetInnerHTML={
                                        section.container ? null : { __html: section.content }
                                    }
                                >
                                    {section.container ? (
                                        <div
                                            className={` ${
                                                data.theme === 'grid'
                                                    ? 'grid-container'
                                                    : 'container'
                                            }`}
                                        >
                                            {data.theme === 'homeMOB' ? (
                                                <Fragment>
                                                    {this.props.browser &&
                                                    this.props.browser.name === 'ie' &&
                                                    (this.props.browser.version === '11.0.0' ||
                                                        this.props.browser.version === '10.0.0' ||
                                                        this.props.browser.version === '9.0.0') ? (
                                                        <HomeIE />
                                                    ) : (
                                                        <Home />
                                                    )}
                                                </Fragment>
                                            ) : data.theme === 'group' ? (
                                                <Group shortname={shortname} />
                                            ) : data.theme === 'company' ? (
                                                <Company request={title} shortname={shortname} />
                                            ) : data.theme === 'private-label-supply-chain' ? (
                                                <PrivateLabelSupplyChain
                                                    request={title}
                                                    shortname={shortname}
                                                />
                                            ) : data.theme ===
                                              'private-label-supply-chain-country' ? (
                                                <PrivateLabelSupplyChainCountry
                                                    request={title}
                                                    shortname={shortname}
                                                    isIE={
                                                        this.props.browser &&
                                                        this.props.browser.name === 'ie'
                                                    }
                                                />
                                            ) : data.theme === 'about' ? (
                                                <About request={title} shortname={shortname} />
                                            ) : data.theme === 'interactive' ? (
                                                <Interactive
                                                    request={title}
                                                    shortname={shortname}
                                                />
                                            ) : data.theme === 'contact' ? (
                                                <Contact />
                                            ) : data.theme === 'grid' ? (
                                                <Grid request={title} shortname={shortname} />
                                            ) : data.theme === 'directors' ? (
                                                <Directors />
                                            ) : data.theme === 'shareprice' ? (
                                                <SharePrice />
                                            ) : data.theme === 'history' ? (
                                                <History />
                                            ) : data.theme === 'keyfacts' ? (
                                                <Fragment>
                                                    {this.props.browser &&
                                                    this.props.browser.name === 'ie' &&
                                                    (this.props.browser.version === '11.0.0' ||
                                                        this.props.browser.version === '10.0.0' ||
                                                        this.props.browser.version === '9.0.0') ? (
                                                        <KeyFactsIE />
                                                    ) : (
                                                        <KeyFacts />
                                                    )}
                                                </Fragment>
                                            ) : data.theme === 'iframe' ? (
                                                <Iframe shortname={shortname} />
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                            );
                        })
                    )}
                    <HomePopup />
                </section>
                {data.theme === 'home' ||
                data.theme === 'directors' ||
                data.theme === 'group' ||
                data.theme === 'private-label-supply-chain' ? null : (
                    <Footer />
                )}
            </Fragment>
        );
    }
}
